export default __webpack_public_path__ + "static/media/linkedin-white.a9df8ee7.svg";